
import * as maplibregl from "maplibre-gl";
import "maplibre-gl/dist/maplibre-gl.css";

export let map: maplibregl.Map;

///////////////////////////
//// Спутник - плоский ////
///////////////////////////
const initSputnikFlat = () => {
    map = new maplibregl.Map({
        container: 'map',
        style: {
            version: 8,
            sources: {
                esri: {
                    type: 'raster',
                    tiles: [
                        'https://server.arcgisonline.com/ArcGIS/rest/services/' +
                        'World_Imagery/MapServer/tile/{z}/{y}/{x}'
                    ],
                    tileSize: 256
                }
            },
            layers: [
                {
                    id: 'esri-satellite',
                    type: 'raster',
                    source: 'esri'
                }
            ]
        },
        center: [39.7787, 43.5550],
        zoom: 14.15
    });

    return map;
}

//////////////////////
//// Спутник - 3D ////
//////////////////////
const initSputnik3D = () => {

    map = new maplibregl.Map({
        container: 'map',
        center: [39.7787, 43.5550],
        zoom: 14.15,
        pitch: 70,
        bearing: -20,
        maxZoom: 18,
        maxPitch: 85,

        style: {
            version: 8,
            sources: {
                esri: {
                    type: 'raster',
                    tiles: [
                        'https://server.arcgisonline.com/ArcGIS/rest/services/' +
                        'World_Imagery/MapServer/tile/{z}/{y}/{x}'
                    ],
                    tileSize: 256
                },
                terrain: {
                    type: 'raster-dem',
                    tiles: [
                        'https://s3.amazonaws.com/elevation-tiles-prod/terrarium/{z}/{x}/{y}.png'
                    ],
                    tileSize: 256,
                    encoding: 'terrarium'
                }
            },
            layers: [
                {
                    id: 'esri-satellite',
                    type: 'raster',
                    source: 'esri'
                },
                {
                    id: 'hillshade',
                    type: 'hillshade',
                    source: 'terrain',
                    paint: {
                        'hillshade-exaggeration': 0.7,
                        'hillshade-shadow-color': '#473B24'
                    }
                }
            ],
            terrain: {
                source: 'terrain',
                exaggeration: 1.2
            }
        }
    });

    map.addControl(new maplibregl.NavigationControl({ visualizePitch: true }));
    map.addControl(new maplibregl.TerrainControl({
        source: 'terrain',
        exaggeration: 1.2
    }));
    return map;
}


//////////////////////
//// Спутник - 3D ////
//////////////////////
const initSputnik3DOffline = () => {

    map = new maplibregl.Map({
        container: 'map',
        center: [39.7787, 43.5550],
        zoom: 14.15,
        pitch: 70,
        bearing: -20,
        maxZoom: 18,
        maxPitch: 85,

        style: {
            version: 8,
            sources: {
                    sat: {
                        type: 'raster',
                        tiles: ['/tiles/sat/{z}/{y}/{x}.jpg'],
                        tileSize: 256
                    },
                    terrain: {
                        type: 'raster-dem',
                        tiles: ['/tiles/dem/{z}/{x}/{y}.png'],
                        tileSize: 256,
                        encoding: 'terrarium'
                    }
                    },
            layers: [
                {
                    id: 'esri-satellite',
                    type: 'raster',
                    source: 'sat'
                },
                {
                    id: 'hillshade',
                    type: 'hillshade',
                    source: 'terrain',
                    paint: {
                        'hillshade-exaggeration': 0.7,
                        'hillshade-shadow-color': '#473B24'
                    }
                }
            ],
            terrain: {
                source: 'terrain',
                exaggeration: 1.2
            }
        }
    });

    map.addControl(new maplibregl.NavigationControl({ visualizePitch: true }));
    map.addControl(new maplibregl.TerrainControl({
        source: 'terrain',
        exaggeration: 1.2
    }));
    return map;
}


//////////////////////
//// Рельеф - плоский ////
//////////////////////
const initReliefFlat = () => {
    map = new maplibregl.Map({
        container: 'map',
        style: {
            version: 8,
            sources: {
                opentopomap: {
                    type: 'raster',
                    tiles: [
                        'https://a.tile.opentopomap.org/{z}/{x}/{y}.png',
                        'https://b.tile.opentopomap.org/{z}/{x}/{y}.png',
                        'https://c.tile.opentopomap.org/{z}/{x}/{y}.png'
                    ],
                    tileSize: 256
                }
            },
            layers: [{
                id: 'opentopomap',
                type: 'raster',
                source: 'opentopomap'
            }]
        },
        center: [39.7787, 43.5550],
        zoom: 14.15
    });
    return map;
}


switch(window.location.pathname){
    case "/":
        map = initSputnikFlat();
        break;
    case "/3d":
        map = initSputnik3D();
        break;
    case "/3d-offline":
        map = initSputnik3DOffline();
        break;
    case "/relief":
        map = initReliefFlat();
        break;
    default:
        console.error("Такого адреса не существует")
        break;
}

const setActivePageSwitcher = (url: string) => {
    const page = document.getElementById('page-switcher');
    if(page){
        const links = page.querySelectorAll('a');
        links.forEach(l => {
            if (l.pathname  == url){
                l.classList.add('active');
            }
        })
    }
}
setActivePageSwitcher(window.location.pathname);